var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _vm.isAward
        ? _c("div", { staticClass: "col-12 mb-3" }, [
            _c("div", { staticClass: "row" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "col-12 col-lg-3" },
                [
                  _c("CustomInputDisplay", {
                    staticClass: "font-weight-bold",
                    attrs: {
                      label: "Fecha de Vencimiento de Fondos:",
                      "label-class": "text-gray font-weight-light",
                      value: _vm.$options.filters.date(
                        _vm.model.fundExpirationDate
                      )
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-lg-3" },
                [
                  _c("CustomInputDisplay", {
                    staticClass: "font-weight-bold",
                    attrs: {
                      label: "Fecha de Fondos Federales:",
                      "label-class": "text-gray font-weight-light",
                      value: _vm.$options.filters.date(
                        _vm.model.federalFundDate
                      )
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-lg-3" },
                [
                  _c("CustomInputDisplay", {
                    staticClass: "font-weight-bold",
                    attrs: {
                      label: "Fecha de Fondos Estatales:",
                      "label-class": "text-gray font-weight-light",
                      value: _vm.$options.filters.date(_vm.model.stateFundDate)
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 col-lg-3" },
                [
                  _c("CustomInputDisplay", {
                    staticClass: "font-weight-bold",
                    attrs: {
                      label: "Período Adicional Renovación:",
                      "label-class": "text-gray font-weight-light",
                      value: _vm.model.additionalRenewalPeriod
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._m(1),
      _c(
        "div",
        { staticClass: "col-12" },
        _vm._l(_vm.model.signers, function(item, index) {
          return _c(
            "div",
            { key: index, staticClass: "mb-3", attrs: { item: item } },
            [
              _c(
                "div",
                {
                  staticClass: "custom-border rounded border-start bg-white p-3"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v(" Nombre: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-normal color-black font-16"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm._f("empty")(item?.name)) + " "
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v(" Puesto: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-normal color-black font-16"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(item?.chargeName)) +
                              " "
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v(" Área: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-normal color-black font-16"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm._f("empty")(item?.area)) + " "
                          )
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-md-3 col-12" }, [
                      _c("div", { staticClass: "color-secondary-6 font-14" }, [
                        _vm._v(" Tipo de Participación: ")
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "font-weight-normal color-black font-16"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(item?.participantType?.name)
                              ) +
                              " "
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "font-18 font-weight-bold m-3" }, [
        _c("i", { staticClass: "fas fa-info-circle text-orange mr-1" }),
        _vm._v(" Información Adicional ")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("label", { staticClass: "font-18 font-weight-bold m-3" }, [
        _c("i", { staticClass: "fas fa-user text-orange mr-1" }),
        _vm._v(" Participantes ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }